import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  HostBinding,
} from '@angular/core';

@Component({
    selector: 'mulo-header-nav-item',
    templateUrl: './header-nav-item.component.html',
    styleUrls: ['./header-nav-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class HeaderNavItemComponent implements OnInit {
  // TODO: Skipped for migration because:
  //  This input is used in combination with `@HostBinding` and migrating would
  //  break.
  @HostBinding('[style.display]') @Input() display: 'block' | 'inline-flex' = 'inline-flex';
  @HostBinding('class') class = 'mulo-header-nav-item';

  constructor() {}

  ngOnInit(): void {}
}
